var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-sidesheet",
    { attrs: { active: _vm.displaySidesheet }, on: { close: _vm.onReset } },
    [
      _c("m-confirm", { ref: "confirm", attrs: { mode: "danger" } }),
      _c(
        "perfect-scrollbar",
        {
          staticClass: "employee-form",
          class: {
            "employee-form-padding": _vm.employeeId,
            "pb-40": !_vm.displayActionShadows,
          },
          attrs: {
            options: {
              suppressScrollX: true,
              suppressScrollY: _vm.selectContainerOpened,
            },
            "watch-options": true,
          },
          on: {
            "ps-scroll-up": _vm.onScroll,
            "ps-y-reach-end": _vm.onScrollEnd,
          },
        },
        [
          _c("div", { staticClass: "employee-form-wrapper" }, [
            _c(
              "div",
              { staticClass: "employee-form__header-wrapper" },
              [
                _c(
                  "div",
                  { staticClass: "employee-form__title-wrapper" },
                  [
                    !_vm.employeeId
                      ? _c("span", { staticClass: "employee-form__title" }, [
                          _vm._v("Добавление сотрудника"),
                        ])
                      : _vm._e(),
                    _vm.employeeId
                      ? [
                          _c(
                            "div",
                            { staticClass: "sidesheet-title-employee-name" },
                            [
                              _c(
                                "span",
                                { staticClass: "employee-form__title" },
                                [_vm._v("Редактирование сотрудника ")]
                              ),
                              _c("span", [_vm._v(_vm._s(_vm.form.fullName))]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "text-15",
                              class: _vm.form.iikoCode ? "d-flex" : "d-none",
                            },
                            [
                              _c("span", { staticClass: "crm-user-label" }, [
                                _vm._v("Пользователь из CRM:"),
                              ]),
                              _c("span", [_vm._v(_vm._s(_vm.form.iikoCode))]),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm.employeeId
                  ? _c("c-button", {
                      staticClass: "employee-remove-button",
                      attrs: {
                        size: "small",
                        label: "Удалить",
                        icon: { icon: "trash", color: "secondary" },
                      },
                      on: { click: _vm.deleteEmployee },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c("div", { staticClass: "employee-form__row d-column" }, [
              _c(
                "div",
                { staticClass: "employee-form__row__item wide-input" },
                [
                  _c("c-input", {
                    class: { "required-field": _vm.errorMessages.fullName },
                    attrs: {
                      "floating-label": "ФИО сотрудника",
                      "max-length": 255,
                      "required-mark": true,
                      clearable: true,
                      required: _vm.errorMessages.fullName,
                      "required-condition": !_vm.form.fullName,
                    },
                    model: {
                      value: _vm.form.fullName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "fullName", $$v)
                      },
                      expression: "form.fullName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "employee-form__row__item wide-input" },
                [
                  _c("c-input", {
                    attrs: {
                      "floating-label":
                        "ФИО в дательном падеже (для договоров)",
                      "max-length": 255,
                      clearable: true,
                    },
                    model: {
                      value: _vm.form.fullNameDativeCase,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "fullNameDativeCase", $$v)
                      },
                      expression: "form.fullNameDativeCase",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "employee-form__row__item wide-input" },
                [
                  _c("c-input", {
                    attrs: {
                      "floating-label":
                        "ФИО в родительном падеже (для договоров)",
                      "max-length": 255,
                      clearable: true,
                    },
                    model: {
                      value: _vm.form.fullNameGenitiveCase,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "fullNameGenitiveCase", $$v)
                      },
                      expression: "form.fullNameGenitiveCase",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "employee-form__row mb-40" }, [
              _c(
                "div",
                { staticClass: "employee-form__row__item" },
                [
                  _c("c-input", {
                    attrs: {
                      "floating-label": "Гражданство",
                      type: "select",
                      clearable: true,
                      searchable: true,
                      items: _vm.collections.citizenships,
                    },
                    on: {
                      "container-opened": _vm.onSelectContainerOpen,
                      "container-closed": _vm.onSelectContainerClose,
                    },
                    model: {
                      value: _vm.form.citizenship,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "citizenship", $$v)
                      },
                      expression: "form.citizenship",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "employee-form__row__item mb-small-0" },
                [
                  _c("c-input", {
                    attrs: {
                      "floating-label": "Правовой статус",
                      type: "select",
                      clearable: true,
                      searchable: true,
                      items: _vm.lawStatuses,
                    },
                    on: {
                      "container-opened": _vm.onSelectContainerOpen,
                      "container-closed": _vm.onSelectContainerClose,
                    },
                    model: {
                      value: _vm.form.lawStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "lawStatus", $$v)
                      },
                      expression: "form.lawStatus",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "employee-form__row" }, [
              _c(
                "div",
                { staticClass: "employee-form__row__item mb-small-0" },
                [
                  _c("c-input", {
                    class: { "required-field": _vm.errorMessages.filial },
                    attrs: {
                      "floating-label": "Филиал",
                      type: "select",
                      clearable: true,
                      searchable: true,
                      "required-mark": true,
                      items: _vm.collections.filials,
                      required: _vm.errorMessages.filial,
                      "required-condition": !_vm.form.filial,
                    },
                    on: {
                      "container-opened": _vm.onSelectContainerOpen,
                      "container-closed": _vm.onSelectContainerClose,
                    },
                    model: {
                      value: _vm.form.filial,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "filial", $$v)
                      },
                      expression: "form.filial",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "employee-form__row__item" },
                [
                  _c("c-checkbox", {
                    staticClass: "mt-20",
                    attrs: { label: "Может работать в нескольких филиалах" },
                    model: {
                      value: _vm.form.isAbleToWorkInDifferentFilials,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "isAbleToWorkInDifferentFilials",
                          $$v
                        )
                      },
                      expression: "form.isAbleToWorkInDifferentFilials",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "employee-form__row__item" },
                [
                  _c("c-input", {
                    attrs: {
                      "floating-label": "Юридическое лицо",
                      type: "select",
                      clearable: true,
                      searchable: true,
                      items: _vm.collections.companies,
                    },
                    on: {
                      "container-opened": _vm.onSelectContainerOpen,
                      "container-closed": _vm.onSelectContainerClose,
                    },
                    model: {
                      value: _vm.form.company,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "company", $$v)
                      },
                      expression: "form.company",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "employee-form__row child-mb-24 mb-md-0" },
              [
                _c(
                  "div",
                  { staticClass: "employee-form__row__item" },
                  [
                    _c("c-input", {
                      attrs: {
                        "floating-label": "Статус сотрудника",
                        type: "select",
                        clearable: true,
                        searchable: true,
                        items: _vm.collections.workerStatuses,
                      },
                      on: {
                        "container-opened": _vm.onSelectContainerOpen,
                        "container-closed": _vm.onSelectContainerClose,
                      },
                      model: {
                        value: _vm.form.workerStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "workerStatus", $$v)
                        },
                        expression: "form.workerStatus",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "employee-form__row__item" },
                  [
                    _vm.showCharacteristic
                      ? _c("c-input", {
                          attrs: {
                            "floating-label": "Характеристика",
                            type: "select",
                            clearable: true,
                            searchable: true,
                            items: _vm.collections.workerCharacteristics,
                          },
                          on: {
                            "container-opened": _vm.onSelectContainerOpen,
                            "container-closed": _vm.onSelectContainerClose,
                          },
                          model: {
                            value: _vm.form.workerCharacteristic,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "workerCharacteristic", $$v)
                            },
                            expression: "form.workerCharacteristic",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "employee-form__row__item" },
                  [
                    _c("c-input", {
                      attrs: {
                        "floating-label": "Статус трудоустройства",
                        type: "select",
                        clearable: true,
                        searchable: true,
                        items: _vm.collections.employmentStatuses,
                      },
                      on: {
                        "container-opened": _vm.onSelectContainerOpen,
                        "container-closed": _vm.onSelectContainerClose,
                      },
                      model: {
                        value: _vm.form.employmentStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "employmentStatus", $$v)
                        },
                        expression: "form.employmentStatus",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "employee-form__row__item" },
                  [
                    _c("c-input", {
                      attrs: {
                        "floating-label": "Рабочий график",
                        type: "select",
                        clearable: true,
                        searchable: true,
                        items: _vm.collections.schedules,
                      },
                      on: {
                        "container-opened": _vm.onSelectContainerOpen,
                        "container-closed": _vm.onSelectContainerClose,
                      },
                      model: {
                        value: _vm.form.schedule,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "schedule", $$v)
                        },
                        expression: "form.schedule",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "employee-form__row__item mb-small-0" },
                  [
                    _c("c-input", {
                      staticClass: "mb-small-0",
                      attrs: {
                        "floating-label": "Тип смены",
                        type: "select",
                        clearable: true,
                        items: _vm.collections.shiftTypes,
                      },
                      on: {
                        "container-opened": _vm.onSelectContainerOpen,
                        "container-closed": _vm.onSelectContainerClose,
                      },
                      model: {
                        value: _vm.form.shiftType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "shiftType", $$v)
                        },
                        expression: "form.shiftType",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "employee-form__row__item" },
                  [
                    _c("c-checkbox", {
                      staticClass: "mt-20",
                      attrs: { label: "Может работать удаленно" },
                      model: {
                        value: _vm.form.isAbleToWorkRemotely,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isAbleToWorkRemotely", $$v)
                        },
                        expression: "form.isAbleToWorkRemotely",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c("div", { staticClass: "employee-form__row mb-small-0" }, [
              _c(
                "div",
                { staticClass: "employee-form__row__item wide-input" },
                [
                  _c("c-input", {
                    attrs: {
                      "floating-label": "Наставник",
                      type: "select",
                      clearable: true,
                      searchable: true,
                      items: _vm.collections.mentors,
                    },
                    on: {
                      "container-opened": _vm.onSelectContainerOpen,
                      "container-closed": _vm.onSelectContainerClose,
                    },
                    model: {
                      value: _vm.form.mentor,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "mentor", $$v)
                      },
                      expression: "form.mentor",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "employee-form__row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "employee-form__row__item mb-small-0 small-input",
                },
                [
                  _c("c-input", {
                    attrs: {
                      label: "Размер депозита, ฿",
                      placeholder: "0",
                      "max-length": 255,
                      clearable: true,
                    },
                    model: {
                      value: _vm.form.depositAmount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "depositAmount", $$v)
                      },
                      expression: "form.depositAmount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "employee-form__row__item" },
                [
                  _c("c-checkbox", {
                    staticClass: "mt-20",
                    attrs: { label: "Начислять зп на личный счет" },
                    model: {
                      value: _vm.form.payOnPersonalAccount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "payOnPersonalAccount", $$v)
                      },
                      expression: "form.payOnPersonalAccount",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "employee-form__row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "employee-form__row__item mb-small-0 small-input",
                },
                [
                  _c("c-input", {
                    ref: "dateInput1",
                    staticClass: "form-group inventory-item-form__issued-date",
                    class: { "form-group--invalid": _vm.issueDateError },
                    attrs: {
                      label: "Дата трудоустройства",
                      type: "date",
                      format: "DD.MM.YYYY",
                      editable: true,
                      icon: "calendar",
                      placeholder: "00.00.0000",
                      "input-text-condition": _vm.issueDateError,
                      "icon-right": true,
                    },
                    on: { invalidDate: _vm.setIssueDateFormatError },
                    model: {
                      value: _vm.form.hiringDateOfficial,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "hiringDateOfficial", $$v)
                      },
                      expression: "form.hiringDateOfficial",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "employee-form__row__item mb-small-0 small-input",
                },
                [
                  _c("c-input", {
                    ref: "dateInput2",
                    staticClass: "form-group inventory-item-form__issued-date",
                    class: { "form-group--invalid": _vm.issueDateError2 },
                    attrs: {
                      label: "Дата увольнения с работы",
                      type: "date",
                      format: "DD.MM.YYYY",
                      editable: true,
                      icon: "calendar",
                      placeholder: "00.00.0000",
                      "input-text-condition": _vm.issueDateError2,
                      "icon-right": true,
                    },
                    on: { invalidDate: _vm.setIssueDateFormatError2 },
                    model: {
                      value: _vm.form.dismissalDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dismissalDate", $$v)
                      },
                      expression: "form.dismissalDate",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "employee-form__row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "employee-form__row__item mb-small-0 small-input",
                },
                [
                  _c("c-input", {
                    ref: "dateInput3",
                    staticClass:
                      "form-group inventory-item-form__issued-date date__agreement",
                    class: { "form-group--invalid": _vm.issueDateError3 },
                    attrs: {
                      label: "Дата договора",
                      type: "date",
                      format: "DD.MM.YYYY",
                      editable: true,
                      icon: "calendar",
                      placeholder: "00.00.0000",
                      "input-text-condition": _vm.issueDateError3,
                      "icon-right": true,
                    },
                    on: { invalidDate: _vm.setIssueDateFormatError3 },
                    model: {
                      value: _vm.form.agreementDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "agreementDate", $$v)
                      },
                      expression: "form.agreementDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "employee-form__row__item mb-small-0 wide-input",
                },
                [
                  _c("c-input", {
                    attrs: {
                      "floating-label": "Номер трудового договора",
                      "max-length": 255,
                      clearable: true,
                      required: _vm.serverErrors.argeement_number,
                      "required-message": _vm.serverErrors.argeement_number,
                    },
                    model: {
                      value: _vm.form.agreementNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "agreementNumber", $$v)
                      },
                      expression: "form.agreementNumber",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "employee-form__positions-wrapper" },
              [
                _c("div", { staticClass: "employee-form__subtitle" }, [
                  _vm._v("Должности"),
                ]),
                _vm._l(_vm.form.positions, function (position, positionIndex) {
                  return _c(
                    "div",
                    {
                      key: positionIndex,
                      staticClass:
                        "employee-form__row position-class child-mb-24 mb-0",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "employee-form__row__item position-input position-width",
                        },
                        [
                          _c("c-input", {
                            class: {
                              "required-field":
                                _vm.errorMessages.positions[positionIndex]
                                  .position,
                            },
                            attrs: {
                              "floating-label": "Должность",
                              type: "select",
                              clearable: true,
                              "required-mark": true,
                              searchable: true,
                              items: _vm.positionsCollection,
                              required:
                                _vm.errorMessages.positions[positionIndex]
                                  .position,
                              "required-condition":
                                !_vm.form.positions[positionIndex].position,
                            },
                            on: {
                              "container-opened": _vm.onSelectContainerOpen,
                              "container-closed": _vm.onSelectContainerClose,
                              input: function ($event) {
                                return _vm.onPositionsInputReset(positionIndex)
                              },
                              clearInput: function ($event) {
                                return _vm.onPositionsInputReset(positionIndex)
                              },
                            },
                            model: {
                              value: _vm.form.positions[positionIndex].position,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.positions[positionIndex],
                                  "position",
                                  $$v
                                )
                              },
                              expression:
                                "form.positions[positionIndex].position",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "employee-form__row__item position-rank tiny-input w-sm-133",
                        },
                        [
                          _c("c-input", {
                            ref: `rank-input-${positionIndex}`,
                            refInFor: true,
                            class: {
                              "required-field":
                                _vm.errorMessages.positions[positionIndex].rank,
                            },
                            attrs: {
                              "floating-label": "Разряд",
                              type: "select",
                              clearable: true,
                              searchable: true,
                              disabled: _vm.isRankSelectDisabled(positionIndex),
                              items: _vm.getRanksCollection(positionIndex),
                              required:
                                _vm.errorMessages.positions[positionIndex].rank,
                              "required-condition":
                                !_vm.form.positions[positionIndex].rank,
                            },
                            on: {
                              "container-opened": _vm.onSelectContainerOpen,
                              "container-closed": _vm.onSelectContainerClose,
                            },
                            model: {
                              value: _vm.form.positions[positionIndex].rank,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.positions[positionIndex],
                                  "rank",
                                  $$v
                                )
                              },
                              expression: "form.positions[positionIndex].rank",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "employee-form__row__item position-specialty",
                        },
                        [
                          _c("c-input", {
                            ref: `specialties-input-${positionIndex}`,
                            refInFor: true,
                            class: {
                              "required-field":
                                _vm.errorMessages.positions[positionIndex]
                                  .specialty,
                            },
                            attrs: {
                              "floating-label": "Специальность",
                              type: "select",
                              clearable: true,
                              searchable: true,
                              disabled:
                                _vm.isSpecialtySelectDisabled(positionIndex),
                              items:
                                _vm.getSpecialtiesCollection(positionIndex),
                              required:
                                _vm.errorMessages.positions[positionIndex]
                                  .specialty,
                              "required-condition":
                                !_vm.form.positions[positionIndex].specialty,
                            },
                            on: {
                              "container-opened": _vm.onSelectContainerOpen,
                              "container-closed": _vm.onSelectContainerClose,
                            },
                            model: {
                              value:
                                _vm.form.positions[positionIndex].specialty,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.positions[positionIndex],
                                  "specialty",
                                  $$v
                                )
                              },
                              expression:
                                "form.positions[positionIndex].specialty",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "employee-form__row__item position-salary small-input w-sm-133",
                        },
                        [
                          _c("c-input", {
                            attrs: {
                              label: "Оклад (для договоров)",
                              placeholder: "0",
                              "max-length": 255,
                              clearable: true,
                            },
                            model: {
                              value: _vm.form.positions[positionIndex].salary,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.positions[positionIndex],
                                  "salary",
                                  $$v
                                )
                              },
                              expression:
                                "form.positions[positionIndex].salary",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("c-button", {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.html",
                            value: {
                              container: "#app",
                              trigger: "hover",
                              content: "Удалить",
                              placement: "top",
                            },
                            expression:
                              "{\n              container: '#app',\n              trigger: 'hover',\n              content: 'Удалить',\n              placement: 'top',\n            }",
                            modifiers: { html: true },
                          },
                        ],
                        staticClass: "mt-20 position-remove-button",
                        attrs: {
                          size: "iconic",
                          icon: { icon: "trash", color: "secondary" },
                          disabled: _vm.form.positions.length === 1,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.removePosition(positionIndex)
                          },
                        },
                      }),
                      _c(
                        "div",
                        {
                          staticClass:
                            "mobile-position-remove-button mobile-only",
                        },
                        [
                          _c("c-button", {
                            attrs: {
                              size: "small",
                              label: "Удалить",
                              icon: { icon: "trash", color: "secondary" },
                              disabled: _vm.form.positions.length === 1,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.removePosition(positionIndex)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                _c("c-button", {
                  staticClass: "add-position-button",
                  attrs: {
                    size: "small",
                    icon: { icon: "plus", color: "primary" },
                    label: "Добавить должность",
                    disabled:
                      _vm.form.positions.length > 0 &&
                      !_vm.form.positions[_vm.form.positions.length - 1]
                        .position,
                  },
                  on: { click: _vm.addPosition },
                }),
              ],
              2
            ),
            _c("div", { staticClass: "employee-form__subtitle" }, [
              _vm._v("Системы учета"),
            ]),
            _c("div", { staticClass: "employee-form__row child-mb-24" }, [
              _c(
                "div",
                { staticClass: "employee-form__row__item" },
                [
                  _c("c-input", {
                    attrs: {
                      "floating-label": "Сервер Timex",
                      type: "select",
                      clearable: true,
                      searchable: true,
                      items: _vm.collections.timexServers,
                    },
                    on: {
                      "container-opened": _vm.onSelectContainerOpen,
                      "container-closed": _vm.onSelectContainerClose,
                    },
                    model: {
                      value: _vm.form.timexServer,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "timexServer", $$v)
                      },
                      expression: "form.timexServer",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "employee-form__row__item" },
                [
                  _c("c-input", {
                    attrs: {
                      "floating-label": "Табельный номер Timex",
                      "max-length": 255,
                      clearable: true,
                    },
                    model: {
                      value: _vm.form.timexNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "timexNumber", $$v)
                      },
                      expression: "form.timexNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "employee-form__row__item small-input w-sm-full",
                },
                [
                  _c("c-input", {
                    attrs: {
                      "floating-label": "Код IIKO",
                      "max-length": 255,
                      clearable: true,
                      required: _vm.serverErrors.iiko,
                      "required-message": _vm.serverErrors.iiko,
                    },
                    model: {
                      value: _vm.form.iikoCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "iikoCode", $$v)
                      },
                      expression: "form.iikoCode",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.displaySidesheet,
                  expression: "displaySidesheet",
                },
              ],
              staticClass: "employee-form__actions",
              class: { "no-shadow": !_vm.displayActionShadows },
            },
            [
              _c("responsive-apply-reset-actions", {
                attrs: {
                  "disable-submit":
                    _vm.isSubmitDisabled || _vm.isSubmited || _vm.isPending,
                  shadows: _vm.displayActionShadows,
                },
                on: { "on-submit": _vm.onSubmit, "on-reset": _vm.onReset },
              }),
            ],
            1
          ),
          _c(
            "b-modal",
            {
              attrs: {
                id: "create-user-employee-modal-success",
                size: "custom-size",
                centered: "",
                "hide-footer": "",
                "hide-header": "",
              },
              model: {
                value: _vm.localActiveSuccessModal,
                callback: function ($$v) {
                  _vm.localActiveSuccessModal = $$v
                },
                expression: "localActiveSuccessModal",
              },
            },
            [
              _c(
                "div",
                { staticClass: "create-user-success-modal" },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "create-user-success-modal-close",
                      attrs: {
                        width: "15",
                        height: "16",
                        viewBox: "0 0 15 16",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                      on: {
                        click: function ($event) {
                          _vm.localActiveSuccessModal = false
                        },
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                          fill: "#8E9CBB",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                          fill: "#8E9CBB",
                        },
                      }),
                    ]
                  ),
                  _c("h2", { staticClass: "create-user-success-modal-title" }, [
                    _vm._v("Сотрудник успешно добавлен"),
                  ]),
                  _vm.record && _vm.record.fullName
                    ? _c(
                        "div",
                        {
                          staticClass: "create-user-success-modal-description",
                        },
                        [
                          _vm._v(
                            " Создать пользователя для нового сотрудника "
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "create-user-success-modal-description-bold",
                            },
                            [_vm._v(_vm._s(_vm.record.fullName.value))]
                          ),
                          _vm._v("? "),
                        ]
                      )
                    : _vm._e(),
                  _c("responsive-apply-reset-actions", {
                    staticClass: "create-user-success-modal-actions",
                    attrs: { "submit-label": "Создать" },
                    on: {
                      "on-submit": _vm.openCreateUserModal,
                      "on-reset": function ($event) {
                        _vm.localActiveSuccessModal = false
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c("m-create-user-for-employee", {
            attrs: {
              id: "create-user-for-employee",
              active: _vm.isActiveCreateUserForEmployeeModal,
              record: _vm.record,
              "modal-title": "Создать пользователя для сотрудника",
            },
            on: {
              close: function ($event) {
                _vm.isActiveCreateUserForEmployeeModal = false
              },
            },
          }),
          _c("to-top-button", { attrs: { element: ".employee-form" } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }